import router from '@/router';
import { landData } from '@/shared/utils/landData';
import { ubtButtonNew, ubtModuleExposeNew } from './index';
import platform from '../platform';

export const getSetupBusinessInfo = (props: Dictionary): Dictionary => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { pageId } = router.app.$route.meta;
  return {
    $screen_height: String(window.screen.height),
    $screen_width: String(window.screen.width),
    $browser: navigator.userAgent,
    $browser_version: navigator.appVersion,
    additionType: '来源',
    additionValue: landData.getSouce(),
    pageId: pageId as string,
    categoryId: 'finance',
    platform: platform.currentPlatformType.platform,
    ...props,
  };
};

export function ubtSetupPageButton(
  buttonName: string,
  otherProps?: Dictionary,
): void {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { pageId } = router.app.$route.meta;
  ubtButtonNew(
    pageId,
    buttonName,
    otherProps,
  );
}

export function ubtSetupModuleExpose(
  buttonName: string,
  otherProps?: Dictionary,
):void {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const { pageId } = router.app.$route.meta;
  ubtModuleExposeNew(
    pageId,
    buttonName,
    otherProps,
  );
}
